module.exports = __webpack_public_path__ + "assets/img/btn-back-8a934a7c.png";